/*
 * @Author: 码上talk|RC
 * @Date: 2021-05-05 09:21:08
 * @LastEditTime: 2022-05-05 09:36:47
 * @LastEditors: 码上talk|RC
 * @Description:
 * @FilePath: /web-m/src/model/entity/region/index.js
 * @微信:  13680065830
 * @邮箱:  3189482282@qq.com
 * @oops: Just do what I think it is right
 */

import Entity from '../../entity.class.js';
import form from '../../json/form/region/regionAllocate';
import options from '../../json/options/region/regionAllocate';

const _tableField = {
  provinceName: {
    type: 'string',
    default: ''
  },
  cityName: {
    type: 'string',
    default: ''
  },
  districtName: {
    type: 'string',
    default: ''
  },
  name: {
    type: 'string',
    default: ''
  }
};

class Region extends Entity {
  static _requestConfig = {
    app: 'm',
    domain: 'region'
  }

  static _form = form

  static _options = options

  constructor (region) {
    super(region, { _tableField });
  }
}

export default Region;

